import React, { createContext, useContext, useEffect } from 'react';
import { serviceRegistry } from '@textile-erp/core';

interface ServiceProviderContextType {
  servicesReady: boolean;
}

const ServiceProviderContext = createContext<ServiceProviderContextType>({
  servicesReady: false,
});

export function useServices() {
  return useContext(ServiceProviderContext);
}

interface ServiceProviderProps {
  children: React.ReactNode;
}

export function ServiceProvider({ children }: ServiceProviderProps) {
  const [servicesReady, setServicesReady] = React.useState(false);

  useEffect(() => {
    const initializeServices = async () => {
      try {
        // Register identity services if available
        try {
          const { IdentityRoleService } = await import('@textile-erp/identity');
          serviceRegistry.registerFactory('roleService', async () => new IdentityRoleService());
        } catch (e) {
          console.log('Identity package not available, continuing without role service');
        }

        // Register user management services if available
        try {
          const { UserLookupService } = await import('@textile-erp/user-management');
          serviceRegistry.registerFactory('userLookupService', async () => new UserLookupService());
        } catch (e) {
          console.log('User management package not available, continuing without user lookup service');
        }

        setServicesReady(true);
      } catch (error) {
        console.error('Failed to initialize services:', error);
        // Still mark as ready to allow app to function without services
        setServicesReady(true);
      }
    };

    initializeServices();
  }, []);

  return (
    <ServiceProviderContext.Provider value={{ servicesReady }}>
      {children}
    </ServiceProviderContext.Provider>
  );
}